import React from "react";
import { assets } from "../assets/assets_frontend/assets";
const Banner = () => {
  return (
    <div className="flex bg-primary items-center px-3 sm:px-14 md:px-14 lg:px-10 my-20 md-">
      <div className="flex-1 py-8 sm:py-10 md:py-16 lg:pl-5 lg:py-24 text-white">
        <div className="text-xl  md:text-3xl lg:text-5xl font-semibold">
          <p className="">book appointments</p>
          <p className=" py-3 ">with 100+ trusted doctors</p>
        </div>
        <button className="bg-white  text-sm sm:text-base px-5 mt-9 py-5 rounded-full text-gray-800">
          create account
        </button>
      </div>
      {/* ........................................... */}
      <div className=" hidden md:block lg:w-[370px] relative">
        <img
          className="w-full absolute bottom-[-150px] max-w-md  "
          src={assets.appointment_img}
          alt={"ls"}
        />
      </div>
    </div>
  );
};

export default Banner;
